import React from 'react';
import { useTimezone } from '@uplift/contexts';
import { useFormContext } from '../AddSessionForm.types';
import { CalendarDateService } from '@uplift/services';
import { patientIsAvailableForDate } from '@uplift/api';
import { DateFormats } from '@uplift/constants';


export const useSessionFormFieldsSync = (props: { open?: boolean; newEvent?: { start?: string } }) => {
  const timezone = useTimezone();
  const formikContext = useFormContext();

  React.useEffect(() => {
    formikContext.setTouched({
      ...formikContext.touched,
      invitedPatient: undefined,
      existingPatient: undefined,
    });
    formikContext.setStatus(undefined);
  }, [ formikContext.values.isNewPatient ]);

  React.useEffect(() => {
    if (!props.open) {
      setTimeout(() => {
        formikContext.setTouched({});
        formikContext.setErrors({});
        formikContext.setValues({
          ...formikContext.initialValues,
          date: formikContext.values.date,
          startTime: props.newEvent?.start ? CalendarDateService.date(props.newEvent?.start).tz(timezone).format() : null,
        });
      }, 350);
    } else if (props.newEvent?.start) {
      const startTimeObj = CalendarDateService.date(props.newEvent?.start).tz(timezone);

      formikContext.setValues({
        ...formikContext.values,
        date: startTimeObj.format(DateFormats.ISO_DATE),
        startTime: startTimeObj.format(),
      });
    }
  }, [ props.newEvent?.start, props.open ]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (formikContext.values.existingPatient?.id && formikContext.values.startTime) {
      patientIsAvailableForDate({
        recurring: formikContext.values.repeats,
        datetime: formikContext.values.startTime,
        patient_id: formikContext.values.existingPatient?.id
      }).then(result => {
        if (result?.error) {
          formikContext.setStatus({ errorDisplayed: true, errorDescription: result.error, submissionBlocked: true });
        } else {
          formikContext.setStatus({ errorDisplayed: false, errorDescription: '', submissionBlocked: false });
        }
      });
    } else {
      formikContext.setStatus({ errorDisplayed: false, errorDescription: '', submissionBlocked: false });
    }
  }, [ formikContext.values.existingPatient, formikContext.values.startTime, formikContext.values.repeats ]); // eslint-disable-line react-hooks/exhaustive-deps

};
